import { create } from "zustand";

const useChatStore = create((set, get) => ({
  messages: [],
  refinedQueries: [],
  setMessages: (messages) => set({ messages }),
  addMessage: (message) =>
    set((state) => ({ messages: [...state.messages, message] })),
  clearMessages: () => set({ messages: [] }),
  setRefinedQueries: (queries) => set({ refinedQueries: queries }),
  addRefinedQuery: (query) =>
    set((state) => {
      if (!state.refinedQueries.includes(query)) {
        const newQueries = [...state.refinedQueries, query].slice(-10);
        return { refinedQueries: newQueries };
      }
      return {};
    }),
  clearRefinedQueries: () => set({ refinedQueries: [] }),
  loadChatHistory: () => {
    const savedMessages = sessionStorage.getItem("chatHistory");
    const savedQueries = sessionStorage.getItem("refinedQueries");
    set({
      messages: savedMessages ? JSON.parse(savedMessages) : [],
      refinedQueries: savedQueries ? JSON.parse(savedQueries) : [],
    });
  },
  saveChatHistory: () => {
    const { messages, refinedQueries } = get();
    sessionStorage.setItem("chatHistory", JSON.stringify(messages));
    sessionStorage.setItem("refinedQueries", JSON.stringify(refinedQueries));
  },
  clearChatHistory: () => {
    sessionStorage.removeItem("chatHistory");
    sessionStorage.removeItem("refinedQueries");
    set({ messages: [], refinedQueries: [] });
  },
}));

export default useChatStore;
